import Icon from 'core/components/icons/Icon'
import { IconType } from 'core/components/icons/types'
import { memo } from 'react'
import { AutosuggestProps } from './Autosuggest'
import { ID } from 'types/entity'

interface AutoSuggestControlsProps<T extends { token_id: ID }> extends Partial<
  AutosuggestProps<T>
> {
  toggleMenu: () => void
  menuExpanded: boolean
  enableClear: boolean
  handleClear: () => void
}

const iconTypeList: string[] = Object.values(IconType)

const AutoSuggestControls = memo(
  <T extends { token_id: ID }>({
    status,
    enableClear,
    handleClear,
    toggleMenu,
    menuExpanded,
    dropdownExpandedIcon,
    suffix
  }: AutoSuggestControlsProps<T>) => {
    if (status === 'loading') {
      return (
        <Icon
          name="loading"
          width={9}
          height={9}
          className="text-xs p-px cursor-pointer"
          color="text-dark-3 hover:text-dark-4"
          onClick={undefined}
        />
      )
    }

    if (enableClear) {
      return (
        <Icon
          name="close"
          width={11}
          height={11}
          className="text-xs p-px cursor-pointer rounded-full bg-dark-3 hover:bg-dark-4"
          color="text-white"
          onMouseDown={handleClear}
        />
      )
    }

    const icon = !enableClear && menuExpanded ? dropdownExpandedIcon : suffix

    if (typeof icon === 'string' && iconTypeList.includes(icon)) {
      return (
        <Icon
          name={icon as IconType}
          width={9}
          height={9}
          className="text-xs p-px cursor-pointer"
          color="text-dark-3 hover:text-dark-4"
          onClick={() => toggleMenu()}
        />
      )
    }

    return (
      <span
        className="cursor-pointer text-xs text-dark-3 hover:text-dark-4"
        onClick={() => toggleMenu()}
      >
        {icon}
      </span>
    )
  }
)

export default AutoSuggestControls
